import * as React from "react";
import { LoaderScreen } from "@grandvisionhq/common";
import { useConfiguratorContext } from "@grandvisionhq/configurator";
import { useDispatch, useSelector, statusSuccess } from "@grandvisionhq/state";
import { useRxGlassesConfiguratorContext } from "../../../../context/context/RxGlassesConfiguratorContext.js";
import "../../../../state/state/actions.js";
import "../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../state/bundles/state/bundles/selectors.js";
import "../../../../state/bundles/state/bundles/reducer.js";
import { getSelectedFrame, getPackages, getSelectedPackage } from "../../../../state/configurator/state/configurator/selectors.js";
import "../../../../state/configurator/state/configurator/reducer.js";
import "../../../../state/products/state/products/selectors.js";
import "../../../../state/products/state/products/reducer.js";
import { ProductSelectionStep } from "../../../components/ProductSelectionStep/steps/components/ProductSelectionStep/ProductSelectionStep.js";
import { selectPackage } from "../../../../state/configurations/state/configurations/actions.js";
const LensPackageStepContainer = () => {
  const dispatch = useDispatch();
  const { goToNextStep } = useConfiguratorContext();
  const { configuratorDocument } = useRxGlassesConfiguratorContext();
  const { readMoreLink } = configuratorDocument?.packageStep ?? {};
  const frame = useSelector(getSelectedFrame);
  const lensPackages = useSelector(getPackages);
  const selectedLensPackage = useSelector(getSelectedPackage);
  const onChange = React.useCallback(
    (sku) => {
      if (!frame) {
        return;
      }
      dispatch(
        selectPackage({
          frameSku: frame.sku,
          packageSku: sku,
          reason: "user selection"
        })
      );
    },
    [dispatch, frame?.sku]
  );
  if (!statusSuccess(lensPackages)) {
    return /* @__PURE__ */ React.createElement(LoaderScreen, null);
  }
  return /* @__PURE__ */ React.createElement(
    ProductSelectionStep,
    {
      onChange,
      onSubmit: goToNextStep,
      itemsList: lensPackages.result,
      selectedItemSku: selectedLensPackage?.sku,
      readMoreLink,
      step: "lensPackage"
    }
  );
};
export {
  LensPackageStepContainer
};
//# sourceMappingURL=LensPackageStepContainer.js.map
